import React from "react";
import styled from "styled-components";

const FallbackContainer = styled.div`
  min-height: 200px;
`;

const SuspenseFallback: React.FC = () => {
  return <FallbackContainer aria-hidden="true" />;
};

export default SuspenseFallback;
